import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaChartGantt } from "react-icons/fa6";
import PerformanceImprovement from "./index";

const performanceImprovementRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Performance Improvement",
        basePath: "performance-improvement",
        mainComponent: <PerformanceImprovement/>,
        layout: "/console", 
        icon: <FaChartGantt className="icon-item" />,
        subTitle:"Performance Improvement",
        level:5,
        moduleId: 0,
    })
]

export default performanceImprovementRoutes;